
import {
  defineComponent, ref, computed, toRaw, watch,
} from 'vue';
import {
  DatePicker, Select, ConfigProvider, Breadcrumb,Button,
} from 'ant-design-vue';

import { useRouter, } from 'vue-router';
import moment, { Moment, } from 'moment';
import { useStore, } from 'vuex';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

const { Item, } = Breadcrumb;

const { RangePicker, } = DatePicker;

export default defineComponent({
  components: {
    ConfigProvider,
    // Breadcrumb,
    RangePicker,
    Button,
    // Item,
  },
  props: {
    customDateShow: {
      type: Boolean,
      defualt: () => false,
    },
    breadcrumbList: {
      type: Array,
      default: () => [
        {
          title: '指挥中心',
          router: '',
        },
        {
          title: '工单管理',
          router: '',
        },
      ],
    },
  },
  setup () {
    const store = useStore();
    const router = useRouter();

    const handlerClick = (path: string) => {
      if (!path) {
        return;
      }

      router.push(`${path}`);
    };

    const curCustomDate = computed(() => store.state.ticket.customDate);
    const curDateString = ref<string[]>([moment(curCustomDate.value[0]).format('YYYY/MM/DD'), moment(curCustomDate.value[1]).format('YYYY/MM/DD'),]);

    // 后端返回的菜单
    const userGrantList = computed(() => store.state.userCenter.userGrantList);

    const customDate = ref<Moment[]>([
      moment(curCustomDate.value[0]), moment(curCustomDate.value[1]),
    ]);
    const onChange = (value: Moment[], dateString: string[]) => {
      customDate.value = value;
      curDateString.value = dateString;
    };

    const search = () => {
      store.dispatch('ticket/changeCustomDate', curDateString.value.map((cur:any) => moment(cur).format('YYYY/MM/DD')));
    };
    const curRouter = ref<string>('');

    const routerList = ref<Array<any>>([]);
    const id = ref<string>('1004');

    const getRouterList = (data: any) => {
      data.forEach((item: any) => {
        if (item.id === id.value) {
          routerList.value = item.children;
        }
      });
    };

    watch(() => userGrantList.value, (cur) => {
      getRouterList(cur);
    });

    getRouterList(userGrantList.value);

    return {
      curRouter,
      zhCN,
      router,
      routerList,
      handlerClick,
      customDate,
      onChange,
      search,
    };
  },
  mounted () {
    this.curRouter = toRaw(this.router).currentRoute.value.fullPath.split('?')?.[0];
  },
});
